import { Component, Input, EventEmitter, Output } from '@angular/core';
import { AppLocaleService } from '@core/services/app-locale.service';

@Component({
	selector: 'cass-price-breakdown',
	templateUrl: './price-breakdown.component.html',
	styleUrls: ['./price-breakdown.component.css']
})
export class PriceBreakdownComponent {

	//Only show NetExCommission and CommissionAmount if CommissionAmount > 0.
	//Only show Tax(calculated as NetIncTax - NetExTax) and NetExTax if Tax > 0.
	//The label "Price including tax" should be "Net price" if tax! > 0

	@Input() issueDateCount?: number = 0;
	@Input() currencyCode?: string;
	@Input() priceMedia?: number;
	@Input() surcharges?: number;
	@Input() priceGross?: number;
	@Input() discounts?: number;
	@Input() netExCommission?: number;
	@Input() commissionAmount?: number;
	@Input() commissionPercentage?: number;
	@Input() priceIncTax?: number;
	@Input() tax?: number;
	@Input() priceExTax?: number;
	@Input() isCalculating: boolean = false;
	@Input() message?: string = "";
	@Input() isError: boolean = false;
	@Input() isDirect: boolean = true;

	@Input() isCustomerNumberApplicable: boolean | undefined = false;

	@Input()
	set initialCustomerNumber(val: string | undefined) {
		if (this._initialCustomerNumber !== val) {
			this._initialCustomerNumber = val;
			if (this._initialCustomerNumber) {
				this.isCustomerNumberSectionShown = true;
			}
			else {
				this.isCustomerNumberSectionShown = false;
			}
		}
	}
	private _initialCustomerNumber: string | undefined = undefined;

	@Input()
	get discountAppliedMessage() {
		return this._discountAppliedMessage;
	}
	set discountAppliedMessage(msg: string) {
		this._discountAppliedMessage = msg;
		this._discountFailedMessage = "";
		this.isCustomerNumberInputDisabled = true;
	}
	private _discountAppliedMessage = "";

	@Input()
	get discountFailedMessage() {
		return this._discountFailedMessage;
	}
	set discountFailedMessage(msg: string) {
		this._discountFailedMessage = msg;
		this._discountAppliedMessage = "";
		this.isCustomerNumberInputDisabled = false;
	}
	private _discountFailedMessage = "";

	get isCustomerNumberSectionShown(): boolean {
		return this._isCustomerNumberSectionShown;
	}
	set isCustomerNumberSectionShown(isChecked: boolean) {
		if (this._isCustomerNumberSectionShown !== isChecked) {
			this._isCustomerNumberSectionShown = isChecked;

			if (!isChecked) {
				this.notifyCustomerNumberChanged(undefined);
				this.isCustomerNumberInputDisabled = true;
			}
			else {
				if (this._initialCustomerNumber) {
					this.customerNumber = this._initialCustomerNumber;
				}

				if (this.customerNumber) {
					this._discountAppliedMessage = "";
					this._discountFailedMessage = "";
				}
				this.isCustomerNumberInputDisabled = false;
			}
		}
	}
	private _isCustomerNumberSectionShown: boolean = false;

	@Output()
	customerNumberChanged = new EventEmitter<string | undefined>();

	customerNumber: string = "";

	isCustomerNumberInputDisabled: boolean = false;

	constructor(private _appLocaleService: AppLocaleService) {
	}

	applyCustomerNumber() {
		this.notifyCustomerNumberChanged(this.customerNumber);
		this.isCustomerNumberInputDisabled = true;
	}

	private notifyCustomerNumberChanged(customerNumber: string | undefined) {
		if (customerNumber) {
			customerNumber = customerNumber.trim();
		}
		this.customerNumberChanged.emit(customerNumber);
	}
}
